/* eslint-disable camelcase */
import DtoManagementUnitAUP from './DtoManagementUnitAUP'
import DtoManagementUnitStationLink from './DtoManagementUnitStationLink'
import { assign } from 'lodash'

export default class DtoManagementUnit {
    constructor(obj) {
        assign(this, obj)
        /* this.managementCode = obj.managementCode
        this.id = obj.id
        this.name = obj.name
        this.descriptive = obj.descriptive
        this.supervisorCode = obj.supervisorCode
        this.operatorCode = obj.operatorCode
        this.parent = obj.parent
        this.lowWaterStartDate = obj.lowWaterStartDate
        this.lowWaterEndDate = obj.lowWaterEndDate
        this.annualBreakdown = obj.annualBreakdown
        this.monthlyBreakdown = obj.monthlyBreakdown
        this.lowWaterVentilation = obj.lowWaterVentilation
        this.lowWaterOutVentilation = obj.lowWaterOutVentilation
        this.x = obj.x
        this.y = obj.y */
        this.labelWithCode = `${obj.id || ''} - ${obj.name || ''}`
        this.codeWithLabel = `[${obj.id || ''}] ${obj.name || ''}`
        this.link_aup = obj.link_aup ? obj.link_aup.map((u) => new DtoManagementUnitAUP(u)) : []
        this.linkStations = obj.linkStations ? obj.linkStations.map((s) => new DtoManagementUnitStationLink(s)) : []
    }
}